import { api } from "../../../config/api";

// Products API
export const getAllProductsApi = async (token, activeOnly = false) => {
  const url = activeOnly ? "/api/products?activeOnly=true" : "/api/products";
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const createProductApi = async (token, data) => {
  return await api.post("/api/products", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateProductApi = async (token, id, data) => {
  return await api.put(`/api/products/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteProductApi = async (token, id) => {
  return await api.delete(`/api/products/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateBranchProductApi = async (token, id, data) => {
  return await api.put(`/api/products/${id}/branch`, data, { headers: { Authorization: `Bearer ${token}` } });
};

// Product Categories API
export const getAllProductCategoriesApi = async (token) => {
  return await api.get("/api/categories", { headers: { Authorization: `Bearer ${token}` } });
};

export const createProductCategoryApi = async (token, data) => {
  return await api.post("/api/categories", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateProductCategoryApi = async (token, id, data) => {
  return await api.put(`/api/categories/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteProductCategoryApi = async (token, id) => {
  return await api.delete(`/api/categories/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// BOM APIs
export const getBomApi = async (token, productId) => {
  return await api.get(`/api/bom/${productId}`, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateBomApi = async (token, productId, bomItems) => {
  return await api.put(`/api/bom/${productId}`, { bomItems }, { headers: { Authorization: `Bearer ${token}` } });
};

// Modifier Groups APIs
export const getAllModifierGroupsApi = async (token, activeOnly = false) => {
  const url = activeOnly ? "/api/modifiers/groups?activeOnly=true" : "/api/modifiers/groups";
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const createModifierGroupApi = async (token, data) => {
  return await api.post("/api/modifiers/groups", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateModifierGroupApi = async (token, id, data) => {
  return await api.put(`/api/modifiers/groups/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteModifierGroupApi = async (token, id) => {
  return await api.delete(`/api/modifiers/groups/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// Modifier Items APIs
export const getModifiersByGroupApi = async (token, groupId, activeOnly = false) => {
  const url = activeOnly ? `/api/modifiers/groups/${groupId}/items?activeOnly=true` : `/api/modifiers/groups/${groupId}/items`;
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const createModifierApi = async (token, groupId, data) => {
  return await api.post(`/api/modifiers/groups/${groupId}/items`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateModifierApi = async (token, id, data) => {
  return await api.put(`/api/modifiers/items/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteModifierApi = async (token, id) => {
  return await api.delete(`/api/modifiers/items/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// Product Modifier Mapping APIs
export const getProductModifierGroupsApi = async (token, productId, activeOnly = false) => {
  const url = activeOnly ? `/api/products/${productId}/modifier-groups?activeOnly=true` : `/api/products/${productId}/modifier-groups`;
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateProductModifierGroupsApi = async (token, productId, groupIds) => {
  return await api.put(`/api/products/${productId}/modifier-groups`, { groupIds }, { headers: { Authorization: `Bearer ${token}` } });
};

// Modifier BOM APIs
export const getModifierBomApi = async (token, modifierId) => {
  return await api.get(`/api/modifiers/items/${modifierId}/bom`, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateModifierBomApi = async (token, modifierId, bomItems) => {
  return await api.put(`/api/modifiers/items/${modifierId}/bom`, { bomItems }, { headers: { Authorization: `Bearer ${token}` } });
};

// Order APIs
export const createOrderApi = async (token, data) => {
  return await api.post("/api/orders", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const getOrdersApi = async (token, status = "") => {
  const url = status ? `/api/orders?status=${status}` : "/api/orders";
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateOrderStatusApi = async (token, id, data) => {
  return await api.patch(`/api/orders/${id}/status`, data, { headers: { Authorization: `Bearer ${token}` } });
};

// Discounts APIs
export const getAllDiscountsApi = async (token, activeOnly = false) => {
  const url = activeOnly ? "/api/discounts?activeOnly=true" : "/api/discounts";
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const createDiscountApi = async (token, data) => {
  return await api.post("/api/discounts", data, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateDiscountApi = async (token, id, data) => {
  return await api.put(`/api/discounts/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteDiscountApi = async (token, id) => {
  return await api.delete(`/api/discounts/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

// Expenses API
export const getAllExpensesApi = async (token, month, year) => { 
  let url = '/api/expenses?';
  if (month) url += `month=${month}&`;
  if (year) url += `year=${year}`;
  return await api.get(url, { headers: { Authorization: `Bearer ${token}` } }); 
};
export const createExpenseApi = async (token, data) => { return await api.post('/api/expenses', data, { headers: { Authorization: `Bearer ${token}` } }); };
export const updateExpenseApi = async (token, id, data) => { return await api.put(`/api/expenses/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }); };
export const deleteExpenseApi = async (token, id) => { return await api.delete(`/api/expenses/${id}`, { headers: { Authorization: `Bearer ${token}` } }); };

// Issue API
export const getIssueReasonsApi = async (token) => { return await api.get('/api/issue/reasons', { headers: { Authorization: `Bearer ${token}` } }); };
export const getAllIssuesApi = async (token) => { return await api.get('/api/issue', { headers: { Authorization: `Bearer ${token}` } }); };
export const getIssueByIdApi = async (token, id) => { return await api.get(`/api/issue/${id}`, { headers: { Authorization: `Bearer ${token}` } }); };
export const createIssueApi = async (token, data) => { return await api.post('/api/issue', data, { headers: { Authorization: `Bearer ${token}` } }); };
export const cancelIssueApi = async (token, id) => { return await api.put(`/api/issue/${id}/cancel`, {}, { headers: { Authorization: `Bearer ${token}` } }); };